import { render, staticRenderFns } from "./MortgageMenu.vue?vue&type=template&id=39828297&scoped=true"
import script from "./MortgageMenu.vue?vue&type=script&lang=js"
export * from "./MortgageMenu.vue?vue&type=script&lang=js"
import style0 from "./MortgageMenu.vue?vue&type=style&index=0&id=39828297&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39828297",
  null
  
)

export default component.exports